module.exports = __webpack_public_path__ + "img/LogoWomenInvestment_Gris.c5800427.png";